import QuestionnaireChoiceStep from "pages/application/templates/shared/QuestionnaireChoiceStep";
import "./single-choice-with-data.scss";
import { getStepData } from "pages/application/question/questionSlice";
import { useSelector } from "react-redux";

const SingleChoiceWithData = () => {
  const stepData = useSelector(getStepData);
  const stepCode = stepData.stepCodeText;
  const stepLabel = stepData.label;
  const { nextStepActions: stepActions, texts: metadata, skipAction } = stepData;

  return (
    <div className="single-choice-with-data">
      <QuestionnaireChoiceStep
        stepActions={stepActions}
        stepCode={stepCode}
        stepLabel={stepLabel}
        metadata={metadata}
        skipAction={skipAction}
      />
    </div>
  );
};

export default SingleChoiceWithData;
